/**
 * 视频比例选择器（按模型 supportedAspectRatios 渲染）
 */

interface VideoAspectRatioSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
}

const ASPECT_LABELS: Record<string, string> = {
  '16:9': '横屏',
  '9:16': '竖屏',
  '1:1': '方形',
  '4:3': '横屏',
  '3:4': '竖屏',
  '3:2': '横屏',
  '2:3': '竖屏',
  '21:9': '超宽屏',
  adaptive: '自适应',
};

export function VideoAspectRatioSelector({ value, onChange, options }: VideoAspectRatioSelectorProps) {
  if (options.length === 0) return null;

  return (
    <div>
      <div className="text-sm font-medium text-light-text mb-2">比例</div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isActive = opt === value;
          const label = ASPECT_LABELS[opt] || '';
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(opt)}
              className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-all ${
                isActive
                  ? 'border-accent-blue bg-accent-blue text-white shadow-md'
                  : 'border-light-border bg-white text-light-secondary hover:border-accent-blue hover:text-accent-blue'
              }`}
            >
              <span className="font-semibold">{opt}</span>
              {label && (
                <span className={`ml-1 text-xs ${isActive ? 'opacity-90' : 'text-light-muted'}`}>
                  {label}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
